module.exports = __webpack_public_path__ + "assets/img/20_157_big.4d664762.jpg";